import DownloadVisitingCards from '../pages/DownloadVisitingCards';
import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import BusinessList from '../components/BusinessList';
import AddBusiness from '../components/AddBusiness';
import EditBusiness from '../components/EditBusiness';
import About from '../pages/about';
import Contact from '../pages/contact';
import SignUp from '../pages/signup';
import BusinessDetail from '../pages/BusinessDetail';
import ViewBusiness from '../pages/ViewBusiness';
import Dashboard from '../pages/Dashboard';
import Login from '../pages/login';
import ForgotPassword from '../pages/ForgotPassword';
import FAQ from '../pages/faq';
import Restaurants from '../pages/restaurants';
import Hotels from '../pages/Hotels';
import Hospitals from '../pages/Hospitals';
import BeautySpa from '../pages/BeautySpa';
import CourierService from '../pages/CourierService';
import Contractors from '../pages/Contractors';
import WeddingPlanning from '../pages/WeddingPlanning';
import PetShops from '../pages/PetShops';
import EstateAgent from '../pages/EstateAgent';
import EventOrganisers from '../pages/EventOrganisers';
import Education from '../pages/Education';
import DrivingSchools from '../pages/DrivingSchools';
import Dentists from '../pages/Dentists';
//import PGHostels from '../pages/PGHostels';
import PopularCategories from '../pages/PopularCategories';
import Loans from '../pages/Loans';
import Gym from '../pages/Gym';
import Electrician from '../pages/Electrician';
import Carpenter from '../pages/Carpenter';
import Plumber from '../pages/Plumber';
import ACService from '../pages/ACService';
import CCTVHomeServices from '../pages/CCTvHomeServices';
import PropertyAgents from '../pages/PropertyAgents';
import Brokers from '../pages/Brokers';
import Institutes from '../pages/Institutes';
import Tutors from '../pages/Tutors';
import CoachingClasses from '../pages/CoachingClasses';
import TrainingCenters from '../pages/TrainingCenters';
import CarBikeHire from '../pages/CarBikeHire';
import DriverOnCall from '../pages/DriverOnCall';
import EquipmentRentals from '../pages/EquipmentRentals';
import Trainers from '../pages/Trainers';
import SportsCoaches from '../pages/SportsCoaches';
import WellnessPrograms from '../pages/WellnessPrograms';
import LoanConsultants from '../pages/LoanConsultants';
import FinancialServices from '../pages/FinancialServices';
import PropertyLoans from '../pages/PropertyLoans';
import InteriorDecorators from '../pages/InteriorDecorators';
import Painters from '../pages/Painters';
import HomeFurnishing from '../pages/HomeFurnishing';
import Salons from '../pages/Salons';
import Massage from '../pages/Massage';
import YogaStudios from '../pages/YogaStudios';
import Photographers from '../pages/Photographers';
import PGHostels from '../pages/PGHostels';
import PackersMovers from '../pages/PackersMovers';
import Privacy from '../pages/privacy';
import Terms from '../pages/terms';
import Cookies from '../pages/cookies';
import SearchResults from '../pages/SearchResults';
import OurStory from '../pages/ourstory';
import ServiceCategoriesGridPage from '../pages/ServiceCategoriesGridPage';
import { Form } from 'react-bootstrap';
import PhotoGallery from '../components/PhotoGallery';
import DashboardLayout from '../pages/DashboardLayout';
import { getImageUrl } from '../utils/imageUtils';
import DashboardOverview from '../pages/DashboardOverview';
import DashboardMyBusinesses from '../pages/DashboardMyBusinesses';
import DashboardReviews from '../pages/DashboardReviews';
import DashboardMessages from '../pages/DashboardMessages';
import DashboardGallery from '../pages/DashboardGallery';
import DashboardFavorites from '../pages/DashboardFavorites';
import DashboardAnalytics from '../pages/DashboardAnalytics';
import DashboardProfileSettings from '../pages/DashboardProfileSettings';
import DashboardBilling from '../pages/DashboardBilling';
import DashboardSupport from '../pages/DashboardSupport';
import NotFound from '../pages/NotFound';

// Component to handle client-side routing redirects
const RouteHandler = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // Check if we need to redirect from sessionStorage
        const redirectPath = sessionStorage.getItem('redirectPath');
        if (redirectPath && location.pathname === '/') {
            sessionStorage.removeItem('redirectPath');
            navigate(redirectPath, { replace: true });
        }
    }, [location, navigate]);

    return null;
};

const AppRoutes = () => {
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        address: '',
        city: '',
        state: '',
        country: '',
        zip_code: '',
        phone: '',
        email: '',
        website: '',
        category: '',
        profile_photo: ''
    });
    const [profilePhoto, setProfilePhoto] = useState(null);

    return (
        <>
            <RouteHandler />
            <Routes>
                <Route path="/" element={<BusinessList />} />
                <Route path="/add-business" element={<DashboardLayout><AddBusiness /></DashboardLayout>} />
                <Route path="/edit-business/:id" element={<EditBusiness />} />
                <Route path="/about" element={<About />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/business/:id" element={<BusinessDetail />} />
                <Route path="/view-business" element={<DashboardLayout><ViewBusiness /></DashboardLayout>} />
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/gallery" element={<PhotoGallery businessId={1} />} />
                
                {/* Footer Pages */}
                <Route path="/faq" element={<FAQ />} />
              
                <Route path="/download-visiting-cards" element={<DownloadVisitingCards />} />
                <Route path="/services-grid" element={<ServiceCategoriesGridPage />} />
                <Route path="/restaurants" element={<Restaurants />} />
                <Route path="/electrician" element={<Electrician />} />
                <Route path="/carpenter" element={<Carpenter />} />
                <Route path="/plumber" element={<Plumber />} />
                <Route path="/acservice" element={<ACService />} />
                <Route path="/cctvhomeservices" element={<CCTVHomeServices />} />
                <Route path="/propertyagents" element={<PropertyAgents />} />
                <Route path="/brokers" element={<Brokers />} />
                <Route path="/pghostels" element={<PGHostels />} />
                <Route path="/estateagent" element={<EstateAgent />} />
                <Route path="/hospitals" element={<Hospitals />} />
                <Route path="/clinics" element={<Hospitals />} />
                <Route path="/dentists" element={<Dentists />} />
                <Route path="/gynecologists" element={<Hospitals />} />
                <Route path="/healthpractitioners" element={<Hospitals />} />
                <Route path="/beautyspa" element={<BeautySpa />} />
                <Route path="/salons" element={<Salons />} />
                <Route path="/massage" element={<Massage />} />
                <Route path="/yogastudios" element={<YogaStudios />} />
                <Route path="/interiordecorators" element={<InteriorDecorators />} />
                <Route path="/contractors" element={<Contractors />} />
                <Route path="/painters" element={<Painters />} />
                <Route path="/homefurnishing" element={<HomeFurnishing />} />
                <Route path="/eventorganisers" element={<EventOrganisers />} />
                <Route path="/weddingplanning" element={<WeddingPlanning />} />
                <Route path="/photographers" element={<Photographers />} />
                <Route path="/education" element={<Education />} />
                <Route path="/institutes" element={<Institutes />} />
                <Route path="/tutors" element={<Tutors />} />
                <Route path="/coachingclasses" element={<CoachingClasses />} />
                <Route path="/trainingcenters" element={<TrainingCenters />} />
                <Route path="/carbikehire" element={<CarBikeHire />} />
                <Route path="/driveroncall" element={<DriverOnCall />} />
                <Route path="/equipmentrentals" element={<EquipmentRentals />} />
                <Route path="/gym" element={<Gym />} />
                <Route path="/trainers" element={<Trainers />} />
                <Route path="/sportscoaches" element={<SportsCoaches />} />
                <Route path="/wellnessprograms" element={<WellnessPrograms />} />
                <Route path="/loans" element={<Loans />} />
                <Route path="/loanconsultants" element={<LoanConsultants />} />
                <Route path="/financialservices" element={<FinancialServices />} />
                <Route path="/propertyloans" element={<PropertyLoans />} />
                <Route path="/petshops" element={<PetShops />} />
                <Route path="/packersmovers" element={<PackersMovers />} />
                <Route path="/courierservice" element={<CourierService />} />
                <Route path="/popularcategories" element={<PopularCategories />} />
                <Route path="/drivingschools" element={<DrivingSchools />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/cookies" element={<Cookies />} />
                <Route path="/search" element={<SearchResults />} />
                <Route path="/ourstory" element={<OurStory />} />
                
                {/* Dashboard Pages */}
                <Route path="/dashboard/overview" element={<DashboardOverview />} />
                <Route path="/dashboard/my-businesses" element={<DashboardMyBusinesses />} />
                <Route path="/dashboard/reviews" element={<DashboardReviews />} />
                <Route path="/dashboard/messages" element={<DashboardMessages />} />
                <Route path="/dashboard/gallery" element={<DashboardGallery />} />
                <Route path="/dashboard/favorites" element={<DashboardFavorites />} />
                <Route path="/dashboard/analytics" element={<DashboardAnalytics />} />
                <Route path="/dashboard/profile-settings" element={<DashboardProfileSettings />} />
                <Route path="/dashboard/billing" element={<DashboardBilling />} />
                <Route path="/dashboard/support" element={<DashboardSupport />} />
                
                {/* Catch-all route for 404 */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </>
    );
};

export default AppRoutes;
